"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function isMemoizePropsEqual(prevProps, newProps) {
  var status = newProps.status;
  var prevStatus = prevProps.status;
  return status === prevStatus;
}

var _default = isMemoizePropsEqual;
exports.default = _default;